import React from 'react';

import HomeImg from 'src/assets/images/home-left.png';

import { lang, useLanguage } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

const HomeLeft = () => {
  useLanguage();
  return (
    <div className={'mc-page-auth-home-left'}>
      <div className={'mc-grow'} />
      <div>
        {lang.t(LANG_CONST.choose_your)}
        <span> {lang.t(LANG_CONST.doctor)}</span>
      </div>
      <div>{lang.t(LANG_CONST.with_lifeapp)}</div>
      <div>{lang.t(LANG_CONST.text.welcome_des)}</div>
      <img src={HomeImg} alt={''} />
    </div>
  );
};

export default HomeLeft;
